import * as z from "zod";

/**
 * Variable registry item - tracks a variable used in the procedure.
 */
const VariableRegistryItemSchema_ = z.object({
  selectionKey: z.string(),
  selectionLabel: z.string(),
  itemKey: z.string().optional(),
  itemLabel: z.string().optional(),
});
export const VariableRegistryItemSchema: z.ZodType<VariableRegistryItem> =
  VariableRegistryItemSchema_;
export interface VariableRegistryItem
  extends z.infer<typeof VariableRegistryItemSchema_> {}

/**
 * Tool registry item - tracks a tool used in the procedure.
 */
const ToolRegistryItemSchema_ = z.object({
  selectionKey: z.string(),
  selectionLabel: z.string(),
  itemKey: z.string().optional(),
  itemLabel: z.string().optional(),
});
export const ToolRegistryItemSchema: z.ZodType<ToolRegistryItem> =
  ToolRegistryItemSchema_;
export interface ToolRegistryItem
  extends z.infer<typeof ToolRegistryItemSchema_> {}
